import { render } from "./riskThreatMaster.vue?vue&type=template&id=53e7bb60&scoped=true&ts=true"
import script from "./riskThreatMaster.vue?vue&type=script&lang=ts"
export * from "./riskThreatMaster.vue?vue&type=script&lang=ts"

import "./riskThreatMaster.vue?vue&type=style&index=0&id=53e7bb60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e7bb60"]])

export default __exports__